import type { BreadcrumbSegment } from '@/types/nav';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { cn } from '@/lib/cn';

interface BreadcrumbProps {
  segments: BreadcrumbSegment[];
  separator?: React.ReactNode;
  className?: string;
}

export function Breadcrumb({ segments, separator, className }: BreadcrumbProps) {
  if (segments.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className={cn('flex items-center gap-1 flex-wrap', className)}>
      <ol className="flex items-center gap-1" role="list">
        {segments.map((segment, index) => (
          <li key={segment.path ?? index} className="flex items-center">
            {index > 0 && (
              <span className="text-[var(--text-muted)]" aria-hidden="true">
                {separator ?? <ChevronRightIcon className="h-4 w-4" />}
              </span>
            )}
            {index === segments.length - 1 ? (
              <span className="text-sm font-medium text-[var(--text-primary)] truncate max-w-[200px]">
                {segment.label}
              </span>
            ) : (
              <Link
                to={segment.path!}
                className="text-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors truncate max-w-[160px]"
              >
                {segment.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}